// Shared country dial-code dataset for phone fields (sign-in, onboarding,
// profile). Mirrors the searchable flag + code + country combobox used in the
// Admin Edit-user form, so every phone picker looks and behaves the same.
import { Country } from 'country-state-city';

const ALL = Country.getAllCountries();

export const PHONE_OPTS = ALL
  .filter((c) => c.phonecode)
  .map((c) => {
    const code = `+${String(c.phonecode).replace('+', '')}`;
    return {
      value: c.isoCode,
      code,
      name: c.name,
      flag: c.flag,
      triggerLabel: `${c.flag} ${code}`,
      label: `${c.flag} ${code} · ${c.name}`,
    };
  });

export const PHONE_BY_ISO = Object.fromEntries(PHONE_OPTS.map((o) => [o.value, o]));

// Resolve an ISO code from a stored dial code (e.g. '+91' → 'IN').
export const isoForDial = (dial, preferIso) => {
  if (preferIso && PHONE_BY_ISO[preferIso]?.code === dial) return preferIso;
  return PHONE_OPTS.find((o) => o.code === dial)?.value || 'IN';
};

export const dialForIso = (iso) => PHONE_BY_ISO[iso]?.code || '+91';
